import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditAddBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.64724 2.50321C5.37646 2.53293 5.17331 2.76483 5.17919 3.03745V5.66752H2.55095C2.53445 5.66679 2.51814 5.66679 2.50163 5.66752C2.36212 5.67394 2.23104 5.73577 2.13717 5.83887C2.04312 5.94216 1.99399 6.07866 2.00059 6.21808C2.007 6.3577 2.06879 6.48887 2.172 6.58298C2.27522 6.67691 2.41143 6.72608 2.55095 6.71947H5.17919V9.34955C5.17717 9.49044 5.23162 9.62602 5.33044 9.72637C5.42925 9.82672 5.564 9.88304 5.7048 9.88304C5.8456 9.88304 5.98035 9.82672 6.07916 9.72637C6.17798 9.62602 6.23243 9.49044 6.23042 9.34955V6.71947H8.85865C8.99945 6.72149 9.13493 6.667 9.23522 6.56812C9.3355 6.46923 9.39178 6.33439 9.39178 6.19349C9.39178 6.05259 9.3355 5.91775 9.23522 5.81887C9.13493 5.71998 8.99945 5.66549 8.85865 5.66751H6.23042V3.03743C6.23372 2.8859 6.17157 2.74041 6.05992 2.63804C5.94809 2.53567 5.79776 2.48652 5.64724 2.50321ZM17.532 3.03745L4.24301 16.3358L8.71097 20.8068L22 7.50853L17.532 3.03745ZM3.72534 17.3136L2.55094 22.5L7.73373 21.3248L3.72534 17.3136Z",
		fill: "currentColor"
	})
});
export default SvgEditAddBox;
